
(function() {
  var haveInsertedScripts = false;

  if(window.location.href.indexOf('/chromeless') > -1 || window.location.href.indexOf('-webview/') > -1 ) {
    // Apps will handle cookie consent differently, so no need to wait for tv2messages
    activateEmbedsAndRemoveShields();
  } else if (window.tv2messages) {
    var log = window.tv2.utils.setupLog('🍪🛡 Embed Cookie Shield');
    window.tv2messages.subscribe('hasConsent', function(hasConsent) {
      log.info('Did' + (hasConsent ? ' ' : ' not ') + 'consent', {haveInsertedScripts});
      if (hasConsent && !haveInsertedScripts) {
        haveInsertedScripts = true;
        activateEmbedsAndRemoveShields();
      }

      if (!hasConsent) {
        // Show Cookie Shields
        var shields = document.querySelectorAll('.tc_embed__cookieshield');
        Array.prototype.forEach.call(shields, function( shieldEle ) {
          shieldEle.style.display = 'block';
        });
      }
    });
  }

  function activateEmbedsAndRemoveShields() {
    function uniqueOnly(value, index, self) {
      return self.indexOf(value) === index;
    }

    // Load external scripts
    (window.cookieShieldExternalScriptSources || []).filter(uniqueOnly).forEach(function(scriptSrc) {
      var scriptEle = document.createElement("script");
      scriptEle.setAttribute('data-source-of-insertion', 'CookieShield');
      scriptEle.src = scriptSrc;
      document.body.appendChild(scriptEle);
    });

    // Load internal scripts
    (window.cookieShieldInlineScripts || []).filter(uniqueOnly).forEach(function(scriptContent) {
      scriptEle.setAttribute('data-source-of-insertion', 'CookieShield');
      var scriptEle = document.createElement("script");
      scriptEle.innerHTML = scriptContent;
      document.body.appendChild(scriptEle);
    });

    // Set src on iframes from data-src
    var iframes = document.querySelectorAll('.tc_embed--shielded iframe');
    Array.prototype.forEach.call(iframes, function( iframe ) {
      const actualSrc = iframe.getAttribute('data-cookie-shield-src');
      if (actualSrc) {
        iframe.setAttribute('src', actualSrc);
      }
    });

    // Remove the shields
    var shields = document.querySelectorAll('.tc_embed__cookieshield');
    Array.prototype.forEach.call(shields, function( shieldEle ) {
      shieldEle.parentNode.removeChild(shieldEle);
    });

    // Show the actual embeds
    var shieldedEmbeds = document.querySelectorAll('.tc_embed--shielded');
    Array.prototype.forEach.call(shieldedEmbeds, function( embed ) {
      embed.classList.remove('tc_embed--shielded');
    });
  }
})()
